export const savingsTiers = [{minimum:2,percentage:10},{minimum:3,percentage:20},{minimum:6,percentage:30}];

export function savingsCopy(count, flavorCount, subscription = false) {
  const tier = savingsTiers.filter(t => count >= t.minimum).at(-1);
  const next = savingsTiers.find(t => t.minimum > count);
  const remaining = next ? next.minimum - count : 0;
  if (subscription) return { headline:'Want to mix & save?', next:'Bundle savings are for one-time packs.', context:'Subscription savings are separate.', progress:0 };
  return {
    headline: tier ? `You've unlocked ${tier.percentage}% off` : 'Mix flavors. Save more.',
    next: next ? `${remaining === 1 ? 'Just 1 more pack' : `Add ${remaining} packs`} to unlock ${next.percentage}% off` : 'Every extra one-time pack saves 30%.',
    context: count ? `${count} ${count === 1 ? 'pack' : 'packs'} in your mix${flavorCount ? ` · ${flavorCount} of this flavor` : ' · Any flavor counts'}` : 'One-time GMM packs. Any flavor counts.',
    progress: Math.min(100, count / (next?.minimum || savingsTiers.at(-1).minimum) * 100),
  };
}

class GmmProductSavings extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.ids = this.dataset.ids.split(',').filter(Boolean);
    this.section = this.closest('.shopify-section');
    this.form = this.closest('form');
    this.cart = null;
    this.sequence = 0;
    const options = {signal:this.abort.signal};
    document.addEventListener('cart:update', () => this.refresh(), options);
    document.addEventListener('variant:update', () => this.render(), options);
    document.addEventListener('change', () => requestAnimationFrame(() => this.render()), options);
    window.addEventListener('pageshow', () => this.refresh(), options);
    window.addEventListener('focus', () => this.refresh(), options);
    this.refresh();
  }
  disconnectedCallback() { this.abort.abort(); this.sequence++; }
  async refresh() {
    const sequence = ++this.sequence;
    try {
      const response = await fetch(`${this.dataset.root}cart.js`, {credentials:'same-origin',cache:'no-store',signal:this.abort.signal});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const {eligibleLines} = await import(this.dataset.mathUrl);
      if (sequence !== this.sequence || !this.isConnected) return;
      this.cart = cart;
      this.lines = eligibleLines(cart,this.ids);
      this.render();
    } catch {
      if (sequence !== this.sequence || !this.isConnected) return;
      this.cart = null;
      this.show({headline:'Mix flavors. Save up to 30%.',next:'See your bundle savings in the cart.',context:'One-time GMM packs only.',progress:0});
    }
  }
  render() {
    if (!this.cart) return;
    const id = this.form?.querySelector('[name="id"]')?.value;
    this.hidden = this.cart.currency !== 'USD' || !this.ids.includes(id);
    if (this.hidden) return;
    const count = this.lines.reduce((sum,line) => sum + line.quantity,0);
    const flavorCount = this.lines.filter(line => String(line.variant_id) === id).reduce((sum,line) => sum + line.quantity,0);
    const subscription = Boolean(this.form?.querySelector('[name="selling_plan"]')?.value) || this.section?.querySelector('[name="purchaseType"]:checked')?.value === 'purchaseTypeSubscription';
    this.show(savingsCopy(count,flavorCount,subscription));
  }
  show(copy) {
    this.querySelector('[data-mini-headline]').textContent = copy.headline;
    this.querySelector('[data-mini-next]').textContent = copy.next;
    this.querySelector('[data-mini-context]').textContent = copy.context;
    this.querySelector('[data-mini-fill]').style.width = `${copy.progress}%`;
    const track = this.querySelector('[role="progressbar"]');
    track.setAttribute('aria-valuenow',String(Math.round(copy.progress)));
    track.setAttribute('aria-valuetext',`${copy.headline}. ${copy.next}`);
  }
}
if (!customElements.get('gmm-product-savings')) customElements.define('gmm-product-savings',GmmProductSavings);
